import { ILearning } from "./interfaces";
import { AxiosInstance } from "axios";

export function getLearningPathModulesBuilder(apiClient: AxiosInstance) {
  return async function getLearningPathModules(options: {
    id: number;
    page: number;
    size: number;
  }): Promise<ILearning.LearningPathModule[] | null> {
    try {
      const response = await apiClient.get("/learning/api/modules", {
        params: {
          paths: options.id,
          ...options,
        },
      });

      return response.data;
    } catch {
      return null;
    }
  };
}
